/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { TemplateScoreHistoryResponse } from '../model/templateScoreHistoryResponse';
// @ts-ignore
import { TenderPhaseType } from '../model/tenderPhaseType';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TemplateScoreHistoryControllerServiceInterface,
    GetTemplateScoreHistoryRequestParams
} from './templateScoreHistoryController.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TemplateScoreHistoryControllerService extends BaseService implements TemplateScoreHistoryControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTemplateScoreHistory(requestParameters: GetTemplateScoreHistoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TemplateScoreHistoryResponse>;
    public getTemplateScoreHistory(requestParameters: GetTemplateScoreHistoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TemplateScoreHistoryResponse>>;
    public getTemplateScoreHistory(requestParameters: GetTemplateScoreHistoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TemplateScoreHistoryResponse>>;
    public getTemplateScoreHistory(requestParameters: GetTemplateScoreHistoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const toolId = requestParameters?.toolId;
        if (toolId === null || toolId === undefined) {
            throw new Error('Required parameter toolId was null or undefined when calling getTemplateScoreHistory.');
        }
        const attributeDirectusId = requestParameters?.attributeDirectusId;
        if (attributeDirectusId === null || attributeDirectusId === undefined) {
            throw new Error('Required parameter attributeDirectusId was null or undefined when calling getTemplateScoreHistory.');
        }
        const phase = requestParameters?.phase;
        if (phase === null || phase === undefined) {
            throw new Error('Required parameter phase was null or undefined when calling getTemplateScoreHistory.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>toolId, 'toolId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>attributeDirectusId, 'attributeDirectusId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>phase, 'phase');

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/providers/templates/scores/history`;
        return this.httpClient.request<TemplateScoreHistoryResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
